// A full-screen lightbox inside an iframe is position:fixed against that
// iframe, so it can only ever cover the frame. In the live-stream chat that
// frame is a ~360px sidebar (ENG-32438).
//
// The framed document doesn't try to fix that itself — it has no business
// restyling whoever embedded it. It just announces what it did, and an embedder
// that wants to react can. Embedders that don't listen are unaffected, which is
// the point: the same slider renders in the forum, comments, ideas, lessons and
// admin, and none of them change behaviour.
//
// Sent by the framed document:
export const LIGHTBOX_OPENED = 'simplero:lightbox-opened'
export const LIGHTBOX_CLOSED = 'simplero:lightbox-closed'

// Sent back by an embedder that has actually made room for it. The framed
// document only goes transparent once it gets this, so an embedder that ignores
// the announcement still gets the normal, frame-sized lightbox.
export const LIGHTBOX_EXPANDED = 'simplero:lightbox-expanded'
export const LIGHTBOX_COLLAPSED = 'simplero:lightbox-collapsed'

// Whoever embedded us, or null when we're not framed.
export const embedderWindow = () => {
  try {
    return window.parent !== window.self ? window.parent : null
  } catch {
    return null
  }
}

// We can't read a cross-origin embedder's origin, and we won't post to '*'.
// Our own origin is the right target: the live page serves the chat frame from
// a bare path, so it is same-origin with us. If some other embedder isn't, the
// browser drops the message rather than delivering it somewhere unintended —
// and it carries no data either way.
export const announceToEmbedder = (type) => {
  const embedder = embedderWindow()
  if (!embedder) return

  try {
    embedder.postMessage({ type }, window.location.origin)
  } catch {
    // A hostile or torn-down embedder is not our problem to solve.
  }
}
